import React, { useState,useEffect, useMemo } from 'react'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonthOutlined';
import MainDateSelector, { isJSON } from '../common/mainDateSelector';
import { Typography, useTheme } from '@mui/material';
import moment from 'moment';
import PopperSelector from '../common/popperSelector';
import { periodTypes, mainTypes, getDateRangeFromString } from '../../../common/utils';
import { useSelector } from 'react-redux';
import { companiesSelector } from '../../../store/slices/company';
import _ from 'lodash';
const defaultDate={startDate:moment().subtract(12, 'month').startOf('day').toDate(),endDate:moment().endOf('day').toDate()}
const invertedPeriodTypes=_.invert(periodTypes)
const periodTypeValues=(id,included)=>{
  switch(id){
    case 0:
      if(included){
        return 'years'
      }
      return 'year'
     case 1:
        if(included){
          return 'quarters'
        }
        return 'quarter'
        case 2:
      if(included){
        return 'months'
      }
      return 'month'
      case 3:
        if(included){
          return 'weeks starting monday'
        }
        return 'week starting monday'
      case 4:
        if(included){
          return 'weeks starting sunday'
        }
        return 'week starting sunday' 
      case 5:
        if(included){
          return 'days'
        }
        return 'day'
  }
}
function isIncluded(type,length){
  const date=moment(new Date())
  const range=type === periodTypes.weekStartMonday?'isoWeek':type === periodTypes.weekStartSunday?'week':type
  const start=date.clone().subtract(length,typeof range==='string'?range: invertedPeriodTypes[range])
  const end=date.clone()
  return {start,end}
}
export function getDateRange (date,selectedMain, periodType, periodLength,included)  {
  const today = moment(date?date:new Date());
  const TT=today.clone().add(-1,'months')
  const TT1=today.clone().add(-1,'year')
  let start, end;

  switch (selectedMain) {
    case mainTypes.allTime:
        start = moment('01/01/2000').clone();
        end = today.clone();
        break;
    case mainTypes.before:
      start = moment('01/01/2000').clone();
      end = today.clone();
      break;
    case mainTypes.on:
      start = today.clone();
      end = today.clone();
      break;
    case mainTypes.current:
      if (periodType === periodTypes.weekStartMonday || periodType === periodTypes.weekStartSunday) {
        const weekStart = periodType === periodTypes.weekStartMonday ? 'isoWeek' : 'week';
        start = today.clone().startOf(weekStart);
        end = today.clone().endOf(weekStart);
      }
      else{
      start = today.clone().startOf(invertedPeriodTypes[periodType]);
      end = today.clone().endOf(invertedPeriodTypes[periodType]);
    }
    if (end.isAfter(moment().clone())) {
      end = today.clone();
    }
      break;
    case mainTypes.after:
     start = today.clone();
      end = moment().clone();
      
      break;
    case mainTypes.last:
      const plength=included?periodLength:periodLength;
      if(included){
        const includedRange=isIncluded(periodType,plength)
        start=includedRange.start
        end=includedRange.end
      }
      else{
       if (periodType === periodTypes.weekStartMonday || periodType === periodTypes.weekStartSunday) {
        const weekStart = periodType === periodTypes.weekStartMonday ? 'isoWeek' : 'week';
        start = today.clone().subtract(plength, 'weeks').startOf(weekStart);
        end = today.clone().subtract(included?0:1, 'weeks').endOf(weekStart);
      }
      else{
      end = today.clone().subtract(included?0:1, invertedPeriodTypes[periodType]).endOf(invertedPeriodTypes[periodType]);
      start = today.clone().subtract(plength, invertedPeriodTypes[periodType]).startOf(invertedPeriodTypes[periodType]);
      }
    }
      if (end.isAfter(moment().clone())) {
        end = today.clone();
      }
      break;
  }
  const startDate = start?.startOf('day').toDate();
  const endDate = end?.endOf('day').toDate();

  return { startDate, endDate };

};
const DatePopper = ({startDate,setStartDate,endDate,setEndDate,range,setRange,disabled=false,width=240}) => {
    const theme = useTheme();
    const [openPopper,setOpenPopper]=useState(false)
    const [periodType,setPeriodType]=useState(0)
    const [periodLength,setPeriodLength]=useState(1)
    const [selectedMain,setSelectedMain]=useState(0)
    const {companies}=useSelector(companiesSelector)
    useEffect(()=>{
      if(range&&typeof range==='string'){
        const rangeObj=getDateRangeFromString(range)
        if(!rangeObj||typeof rangeObj!=='object') return
        const main=rangeObj['mainType']??0
        const pType=rangeObj['periodType']??0
        const pLength=_.isNaN(_.parseInt(rangeObj['days']))?1:_.parseInt(rangeObj['days'])
        const included=rangeObj['included']??false
        const selectedDate=getDateRange((main===4||main===5)?new Date():moment(rangeObj.start).toDate(),main,pType,pLength,included)
          setStartDate(moment(selectedDate.startDate?selectedDate.startDate:rangeObj.start?rangeObj.start:defaultDate.startDate).format('YYYY-MM-DDTHH:mm:ss'))
          setEndDate(moment(selectedDate.endDate?selectedDate.endDate:rangeObj.end?rangeObj.end:defaultDate.endDate).format('YYYY-MM-DDTHH:mm:ss'))
      }
    },[companies,range])
    const tooltipText=useMemo(()=>{
      let string='Time Period\n'
      // export const mainTypes={betweeen:0,on:1,before:2,after:3,last:4,current:5,allTime:7,custom:6};
      const rangeObj=getDateRangeFromString(range)
      const start=rangeObj?.start?moment(rangeObj?.start).format('MM/DD/YYYY'):''
      const end=rangeObj?.end?moment(rangeObj?.end).format('MM/DD/YYYY'):''
      const mainType=rangeObj?.mainType??""
      const includedPeriodValues=periodTypeValues(rangeObj?.periodType??"")
      const days=rangeObj?.days??""
      const periodType=periodTypeValues(rangeObj?.periodType??"",(days>1))
      const included=!!rangeObj?.included
      switch (mainType) {
        case 1:
          const s1="On: "
          string+=(" "+s1+start)
         return string;
        case 2:
        const s2='Before: '
        string+=(" "+s2+start)
       return string;
        case 3:
        const s3='After: '
         string+=(" "+s3+start)
        return string;
        case 4:
          const s4='Last: '
           string+=(s4+days+" "+periodType)
           if(included){
            string+=' (including current '+includedPeriodValues+')'
           }
           return string;
        case 5:
          const s5='Current: '
          string+=(s5+periodType)
         return string;;
        case 7:
          string+='All Time'
          return string;
        default:
          string+=(" "+start+" - "+end )       
          return string;
      }
      
    },[range])
  return (
    <PopperSelector tooltipText={<Typography variant='caption' whiteSpace={'pre-line'}>{tooltipText??"Time period"}</Typography>} slotProps={{popper:{width:'unset',disablePortal:true}}} disabled={disabled} icon={<CalendarMonthIcon fontSize='small'/>} open={openPopper} setOpen={setOpenPopper} width={width} value={startDate&&endDate?<span style={{color:theme.palette.text.primary}}>{`${moment(startDate).format('MM/DD/YYYY')} ~ ${moment(endDate).format('MM/DD/YYYY')}`}</span>:'Time Period'}>
        {openPopper&&<MainDateSelector setOpenPopper={setOpenPopper} selectedMain={selectedMain} setSelectedMain={setSelectedMain} periodLength={periodLength}setPeriodLength={setPeriodLength} periodType={periodType} setPeriodType={setPeriodType}  startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} range={range} setRange={setRange}/>}
    </PopperSelector>
  )
}

export default DatePopper